import { Component, OnInit, ViewChildren, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { saveAs } from '@progress/kendo-file-saver';
import { geometry, fit, exportPDF, Group, drawDOM, exportImage, DrawOptions } from '@progress/kendo-drawing';
import { PhBhpFeaturePackageSopobservationService } from '../ph-bhp-feature-package-sopobservation.service'
import { SopStep, Comments, SelectedStep } from '../Models';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-sop-observe-pdf-export',
  templateUrl: './ph-bhp-sop-observe-pdf-export.component.html',
  styleUrls: ['./ph-bhp-sop-observe-pdf-export.component.css']
})

export class PhBhpSopObservePdfExportComponent implements OnInit {
  @Input() clickNoSterility: Boolean = false;
  @Input() comments: Array<Comments> = [];
  @Input() format;
  @Input() formdata: any;
  @Input() isDesktop = true;
  @Input() isDownload = false;
  @Input() seletedSteps: Array<Array<SelectedStep>> = [];
  @Input() sopDescription;
  @Input() sopName;
  @Input() sopStep: Array<SopStep>;
  @Output() action = new EventEmitter();
  @ViewChild('cardHolder') cardHolder;
  @ViewChild('userCommentFrom') userCommentFrom;
  @ViewChild('pdf') pdfGenerator: any;
  @ViewChildren('card') cards;
  @Input() predefinedComments: Array<any> = [];
  hovered = false;
  isCollapsed = true;
  numberToName: Array<string> = [];
  quickComment: Array<string> = ["Hand Disinfection Wrong", "Process Interupted", "Process"];
  quickCommentIndex: String;
  showProfessionalSubcategory;
  showStepList: Object = {};
  sopStepLength: number;
  stepCount: number = 0;
  stepName: String;
  stepNumber: number;
  stepObservations = [];
  translationKeys: typeof TranslationKeys = TranslationKeys;
  userComment: string;
  swappedSteps: boolean = false;
  logoSrc = 'assets/img/app-logo.svg';

  constructor(public service: PhBhpFeaturePackageSopobservationService, public layoutService: PHBHPLayoutPackageService, public modalRef: BsModalRef) { }

  ngOnInit() {
    this.loadLogo();
    this.initData();

    if (this.isDownload) {
      this.layoutService.showLoader = true;
      this.callTimeoutDownload();
    }
  }

  private initData() {
    if (this.sopStep) {
      this.sopStepLength = this.sopStep.length - 1;
      this.showStepList = {};
      this.sopStep.forEach((step, index) => {
        var selectedStep = this.seletedSteps[index];
        if (selectedStep) {
          this.showStepList[index] = true;
        }
      });
      this.updateSwappedFlags();
      this.callTimeOutLine();
    }

    for (let i = 0; i < this.comments.length; i++) {
      var comment = this.comments[i];
      if (comment.commentType == 1) {
        var predefinedComment = this.predefinedComments.find(predefinedComment => predefinedComment.predefinedCommentID === comment.predefineCommentID);
        if (predefinedComment) {
          switch (predefinedComment.commentName) {
            case 'jewellery / wrist watch':
              this.comments[i].predefinedCommentText = this.layoutService.translateText('SOP_OBSERVATION.JEWELLERY_OR_WRIST_WATCH');
              break;
            case 'artificial finger nails / nail varnish':
              this.comments[i].predefinedCommentText = this.layoutService.translateText('SOP_OBSERVATION.ARTIFICIAL_NAILS_OR_VARNISH');
              break;
            case 'Hand disinfection executed incorrectly':
              this.comments[i].predefinedCommentText = this.layoutService.translateText('SOP_OBSERVATION.HAND_DISINFECTION_WRONG_EXECUTED');
              break;
            case 'Skin antisepsis executed incorrectly':
              this.comments[i].predefinedCommentText = this.layoutService.translateText('SOP_OBSERVATION.SKIN_ANTISEPSIS_WRONG_EXECUTED');
              break;
            case 'Process interrupted':
              this.comments[i].predefinedCommentText = this.layoutService.translateText('SOP_OBSERVATION.PROCESS_INTERRUPTED');
              break;
            default:
              this.comments[i].predefinedCommentText = predefinedComment.commentName;
          }
        }
      }
    }

    this.service.getConfigDetails(this.layoutService.institutionID).subscribe((res) => {
      if (this.showProfessionalSubcategory) {
        this.showProfessionalSubcategory = res.enableProfessionalSubCategory;
      }
    });
  }

  showStep(index) {
    if (!this.seletedSteps[index]) {
      this.seletedSteps[index] = [];
    }
    if (!this.showStepList[index]) {
      this.showStepList[index] = true;
    }
    this.callTimeOutLine()
  }

  removeCardLine() {
    var childNodes = this.cardHolder.nativeElement.childNodes;
    childNodes.forEach((child, index) => {
      if (child.classList && child.classList.contains('horz-Line')) {
        child.remove()
      }
    })
  }

  cardNextLine() {
    var winWidth = window.innerWidth;
    let addChildNodeAtLast = false;
    this.cards.forEach((card, index) => {
      var phElement = card.nativeElement;
      if (this.cards._results[index + 1]) {
        this.cards._results[index + 1].nativeElement.classList.remove('nextRowFirstCard');
      }
      phElement.classList.remove('rowLastCard')

      var childNodes = phElement.childNodes[0];
      if (childNodes.classList && childNodes.classList.contains('rowLastCard1')) {
        childNodes.remove()
      }
      if (childNodes.classList && childNodes.classList.contains('nextRowFirstCard1')) {
        childNodes.remove()
      }

      // mutli-step-start-image
      if (this.cards._results[index + 1] && phElement.classList.contains('mutli-step-start-image')) {
        const childNodesOfMultiStack = phElement.childNodes;

        // use for each instead
        childNodesOfMultiStack.forEach(element => {
          if (element.classList && element.classList.contains('start-image-end')) {
            addChildNodeAtLast = true;
            element.remove();
          }
        });
      }

      var cardWidth = phElement.offsetWidth;
      var cardHeight = phElement.offsetHeight;
      var cardLeft = phElement.offsetLeft;
      var cardTop = phElement.offsetTop;
      var difWidth = winWidth - (cardWidth + cardLeft);
      var difHeight = cardTop + cardHeight;
      var mutliStep = false;
      if (phElement.classList.contains('mutli-step-sub-cards')) {
        mutliStep = true;
      }
      if (mutliStep) {
        var tempCardWidth = cardWidth;
      } else {
        var tempCardWidth = cardWidth + 14;
      }

      if (mutliStep) {
        var difWidth = winWidth - (cardWidth - 14 + cardLeft);
      } else {
        var difWidth = winWidth - (cardWidth + cardLeft);
      }

      if (difWidth < (tempCardWidth + 26)) {
        phElement.classList.add('rowLastCard');
        phElement.insertAdjacentHTML('afterbegin', `<div class='rowLastCard1'></div>`);
        if (this.cards._results[index + 1]) {
          var phElement1 = this.cards._results[index + 1].nativeElement;
          phElement1.classList.add('nextRowFirstCard');
          phElement1.insertAdjacentHTML('afterbegin', `<div class='nextRowFirstCard1'></div>`);
          this.cardHolder.nativeElement.insertAdjacentHTML('afterbegin', "<div class='horz-Line' style='top:" + (difHeight + 14) + "px;width:" + (cardLeft - 56) + "px'></div>");
        }
      }

      if (addChildNodeAtLast && (this.cards.length === index + 1)) {
        addChildNodeAtLast = false;
        let endImage = document.createElement('div');
        endImage.className = 'start-image-end d-flex align-items-center';

        phElement.appendChild(endImage);
      }
    });
  }

  callTimeOutLine() {
    setTimeout(() => {
      this.removeCardLine();
      this.cardNextLine()
    }, 1)
  }

  onchildData(value) {
    switch (value.key) {
      case 'close':
        this.isCollapsed = !this.isCollapsed;
        break;
    }
  }

  errImg(e: Event) {
    e.target['src'] = 'assets/img/fallback-img.png';
  }

  getFileName(extension: string): string {
    const parts = this.formdata.creationDate.split('/');
    const date = new Date(parseInt(parts[2], 10), parseInt(parts[0], 10) - 1, parseInt(parts[1], 10));
    const formattedDate = date.getFullYear()
      + '.' + ('0' + (date.getMonth() + 1)).slice(-2)
      + '.' + ('0' + date.getDate()).slice(-2);

    return `${formattedDate}_SOP_Observation.${extension}`;
  }

  callTimeoutDownload() {
    setTimeout(() => {
      if (this.format === 'pdf') {
        this.pdfGenerator.saveAs(this.getFileName('pdf'));
      } else {
        drawDOM(this.pdfGenerator.element.nativeElement).then((group: Group) => {
          return exportImage(group);
        }).then((data) => {
          saveAs(data, this.getFileName('png'));
        });
      }
      this.modalRef.hide();
      this.layoutService.showLoader = false;
    }, 8000);
  }

  getPredefinedCommentText(predefinedCommentId) {
    var predefinedComment = this.predefinedComments.find(comment => comment.predefinedCommentID === predefinedCommentId);
    var commentText = predefinedComment ? predefinedComment.commentName : '';
    return this.layoutService.getTranslationKey(commentText);
  }

  private updateSwappedFlags(): void {
    const visitedStepOrders: Set<number> = new Set();
    this.swappedSteps = false;

    for (const stepGroup of this.seletedSteps) {
      if (stepGroup) {
        for (let i = 0; i < stepGroup.length; i++) {
          const stepCard = stepGroup[i];
          if (stepCard) {
            if (!this.previousStepsExist(visitedStepOrders, stepCard.stepOrder)) {
              stepCard.swapped = true;
              this.swappedSteps = true;
            } else {
              stepCard.swapped = false;
            }
            visitedStepOrders.add(stepCard.stepOrder);
          }
        }
      }
    }
  }

  private previousStepsExist(set: Set<number>, x: number): boolean {
    for (let i = 1; i < x; i++) {
      if (!set.has(i)) {
        return false;
      }
    }
    return true;
  }

  private loadLogo(): void {
    this.layoutService.getAppLogoBase64()
      .then((logo) => {
        if (!logo) {
          return;
        }

        this.logoSrc = logo;
      })
      .catch(() => {
        // Keep default asset path fallback if conversion fails
        this.logoSrc = 'assets/img/app-logo.svg';
      });
  }
}
